import { dupLangHu } from './hu/dup_lang';
import { dupLangEn } from './en/dup_lang';

export type DupLang = typeof dupLangHu;

export const getDupLang = (language: string): DupLang => {
  return language === 'en' || language === 'English' ? dupLangEn : dupLangHu;
};
